module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"see_all_reviews":"View all product reviews","create_review":"Write a Review"}}')
  delete Component.options._Ctor
}
